/*
 These constants are to define the 'trackingCaller' property passed on auth.signIn
 */

// sign in process is forced
export const FORCED = 'forced';
// sign in was prompted by the cta that is displayed when cart is empty
export const EMPTY_CART_SIGN_IN_CTA = 'empty-cart-signin-cta';
// sign in was prompted by the button cta that is displayed when cart is empty
export const EMPTY_CART_SIGN_IN_CTA_BUTTON = 'empty-cart-signin-cta-button';
// sign in was prompted by the cta
export const SIGN_IN_CTA = 'cart-signin-cta';
